import React from 'react';

import { useConversion } from 'app/developer-v3/hooks';

import CTAs from './CTAs';

type Props = {
  integrationId: ID;
  wasConvertedFromWB: boolean;
};

function CTAWBConversion(props: Props) {
  const { integrationId, wasConvertedFromWB } = props;

  const conversion = useConversion();

  return conversion.stage ? (
    <CTAs.ConversionMigration
      appId={integrationId}
      isMigrated={conversion.isMigrated}
      migrationDate={conversion.migratedDate}
      wasConvertedFromWB={wasConvertedFromWB}
    />
  ) : null;
}

export default CTAWBConversion;
